<template>
    <span v-if="occupancyTaxID">
        <b-button
            class="align-baseline mr-1"
            title="Edit"
            variant="default"
            @click="handleEditOccupancyTax"
        >
            <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
        </b-button>
        <b-button
            class="align-baseline"
            title="Delete"
            variant="default"
            v-b-modal="deleteModalID"
        >
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <modal
            :id="deleteModalID"
            title="Delete Occupancy Tax"
            @shown="onModalShown"
            @ok="handleDeleteOccupancyTax"
            >Are you sure you want to delete {{ occupancyTaxName }}?</modal
        >
    </span>
</template>

<script>
import Modal from '../../../generic/modal/modal.vue';

export default {
    components: {
        Modal,
    },
    data() {
        return {
            occupancyTaxID: 0,
            occupancyTaxName: '',
            deleteModalID: '',
        };
    },
    created() {
        this.occupancyTaxID = this.params.data && this.params.data.id;
        this.occupancyTaxName = this.params.data && this.params.data.name;
        this.deleteModalID = `modal-delete-occupancy-tax-${this.occupancyTaxID}`;
    },
    methods: {
        onModalShown() {
            this.params.api.clearFocusedCell();
        },
        handleEditOccupancyTax() {
            this.params.update && this.params.update(this.params.data);
        },
        handleDeleteOccupancyTax() {
            this.params.delete && this.params.delete(this.params.data);
        },
    },
};
</script>
